import { Reducer } from 'redux';
import { MedicineState, MedicineType } from './type';

const initialState: MedicineState = {
  list: [],
  info: {},
  prescriptionInfo: {
    patientId:'',
    illnessDesc:{},
    attachmentId:[],
    patientInfo:{
      patientName: '',
    },
    prescriptionId:'',
  },
  selectPatientItem: {
    id: '',
    patientName: '',
    patientAge: '',
    patientGender: '',
    patientPhone: '',
    patientRelation: '',
    patientCertType: 'I',
    patientCertNo: '',
    patientHealth: {},
  },
  illnessDesc:[],
  tmpIllnessDesc:{},
  attachmentList:[],
};

const reducer: Reducer<MedicineState> = (state = initialState, action) => {
  switch (action.type) {
  case MedicineType.ADD_MEDICINE: {
    const { data: {list, info} } = action;
    return {
      ...state,
      list,
      info,
    };
  }
  case MedicineType.CLEAR_MEDICINE: {
    return {
      ...state,
      list: {},
      info: [],
    };
  }
  case MedicineType.ADD_PRESCRIPTION_TO_CHART: {
    const { payload } = action;
    return {
      ...state,
      ...payload,
    };
  }
  case MedicineType.SELECT_PATIENT_ITEM: {
    const { payload } = action;
    return {
      ...state,
      selectPatientItem: {
        ...payload,
      },
    };
  }
  case MedicineType.EDIT_PATIENT_INFO: {
    const { key, value } = action;
    return {
      ...state,
      selectPatientItem: {
        ...state.selectPatientItem,
        [`${key}`]: value,
      },
    };
  }
  case MedicineType.EDIT_PATIENT_HEALTH: {
    const { key, value } = action;
    return {
      ...state,
      selectPatientItem: {
        ...state.selectPatientItem,
        patientHealth: {
          ...state.selectPatientItem.patientHealth,
          [`${key}`]: JSON.stringify(value),
        },
      },
    };
  }
  case MedicineType.UPDATE_PRESCRIPTION_INFO: {
    const { payload } = action;
    return {
      ...state,
      prescriptionInfo: {
        ...state.prescriptionInfo,
        ...payload,
      },
    };
  }
  case MedicineType.UPDATE_PRESDRUG_INFO: {
    const { payload } = action;
    return {
      ...state,
      ...payload,
    };
  }
  case MedicineType.SUBMIT_PRESCRIPTION_SUCCESS: {
    const { payload } = action;
    console.log('payload',payload);
    return {
      ...state,
      prescriptionInfo: payload,
    };
  }
  case MedicineType.FETCH_PRESCRIPTION_SUCCESS: {
    const { payload } = action;
    console.log('payload',payload);
    return {
      ...state,
      prescriptionInfo: payload,
    };
  }
  case MedicineType.CLEAR_PRESCRIPTION: {
    return {
      ...state,
      prescriptionInfo: {},
      selectPatientItem: {},
      attachmentList:[],
      illnessDesc:[],
      tmpIllnessDesc:{},
    };
  }
  case MedicineType.UPDATE_ILLENESS: {
    const { payload } = action;
    return {
      ...state,
      illnessDesc: payload,
    };
  }
  case MedicineType.UPDATE_TMPILLNESS: {
    const { payload } = action;
    return {
      ...state,
      tmpIllnessDesc: payload,
    };
  }
  case MedicineType.CLEAR_SELECT_PATIENT_ITEM: {
    return {
      ...state,
      selectPatientItem: {},
    };
  }
  case MedicineType.CLEAR_ATTACHMENTlIST: {
    return {
      ...state,
      attachmentList: [],
    };
  }
  case MedicineType.UPDATE_ATTACHMENTLIST: {
    const { payload } = action;
    return {
      ...state,
      attachmentList: payload,
    };
  }
  case MedicineType.ADD_ATTACHMENT: {
    const { payload } = action;
    return {
      ...state,
      attachmentList: [...state.attachmentList, payload],
    };
  }
  default: {
    return state;
  }
  }
};

export { reducer as MedicineReducer };
